var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfiguration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4292 11.593C22.1106 12.7675 22.4513 13.3547 22.4513 13.9999C22.4513 14.6451 22.1106 15.2322 21.4292 16.4068L19.8034 19.209C19.1247 20.3789 18.7854 20.9639 18.2273 21.2849C17.6692 21.606 16.9919 21.606 15.6373 21.606H12.3628C11.0082 21.606 10.3309 21.606 9.7728 21.2849C9.21474 20.9639 8.87539 20.3789 8.19669 19.209L6.57093 16.4068C5.88953 15.2322 5.54883 14.6451 5.54883 13.9999C5.54883 13.3547 5.88953 12.7675 6.57093 11.593L8.19669 8.79074C8.87539 7.62088 9.21474 7.03596 9.7728 6.71488C10.3309 6.3938 11.0082 6.3938 12.3628 6.3938H15.6373C16.9919 6.3938 17.6692 6.3938 18.2273 6.71488C18.7854 7.03596 19.1247 7.62089 19.8034 8.79075L21.4292 11.593Z",
    stroke: "#121217",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4648 10.6194L16.5356 17.3804",
    stroke: "#121217",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/configuration.9f750385abc82a66b1f72b088bae8883.svg";
export { ForwardRef as ReactComponent };